import {defineMessages, FormattedMessage} from '@pinecast/i18n';
import * as React from 'react';

const messages = defineMessages({
  required: {
    id: 'db-spa.validation.required',
    description:
      "Error shown when a value is required but hasn't been provided",
    defaultMessage: 'This field cannot be left blank.',
  },
  noHTML: {
    id: 'db-spa.validation.noHTML',
    description:
      'Error shown when a value is not supposed to contain HTML but does',
    defaultMessage: 'You cannot use HTML code here.',
  },
  url: {
    id: 'db-spa.validation.url',
    description:
      'Error shown when a value is supposed to be a URL but is malformed',
    defaultMessage: 'URLs must start with http:// or https://.',
  },
});

export function required(value: any): React.ReactNode {
  if (value) {
    return undefined;
  }
  return <FormattedMessage {...messages.required} />;
}

export function noHTML(value: any): React.ReactNode {
  if (value && value.includes('<')) {
    return <FormattedMessage {...messages.required} />;
  }
  return undefined;
}

export function url(value: string): React.ReactNode {
  if (value && !value.match(/^https?:\/\//)) {
    return <FormattedMessage {...messages.url} />;
  }
  return undefined;
}

export function composeValidation(
  ...rules: Array<(value: any) => React.ReactNode | undefined>
) {
  return (value: any) => {
    for (const rule of rules) {
      const result = rule(value);
      if (result) {
        return result;
      }
    }
    return undefined;
  };
}
